import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=55cc7526&scoped=true&"
var script = {}
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=55cc7526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cc7526",
  null
  
)

export default component.exports